<template>

<div class="row justify-content-center">
    <div class="col-md-10">

        <div v-if='!isSent && !failed' class="fieldset bg-white shadow-lg">

            <h3 class="fieldset-title mb-1">Свържи се с нас</h3>
            
            <p class="text-center mb-4 pb-2 text-muted">
                Всички полета, отбелязани със * са задължителни.
            </p>

            <div class="row">

                <div class="col-12 col-md-6">
                    <div class="form-group mb-3">
                        <label for="name">Име и фамилия*:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <span class="icon icon-user"></span>
                                </div>
                            </div>
                            <input type="text" v-model='model.name' 
                                   class="form-control input-lg" 
                                   id="name" required autofocus="autofocus">
                        </div>
                    </div>
                </div>
            
                <div class="col-12 col-md-6">
                    <div class="form-group mb-3">
                        <label for="email">E-mail адрес*:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <span class="icon icon-envelope"></span>
                                </div>
                            </div>
                            <input type="email" v-model='model.email' 
                                   class="form-control input-lg" id="email" required>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">

                <div class="col-12 col-md-6">
                    <div class="form-group mb-3">
                        <label for="phone">Телефонен номер:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <span class="icon icon-phone"></span>
                                </div>
                            </div>
                            <input type="phone" v-model='model.phone' 
                                   class="form-control input-lg" id="phone">
                        </div>
                    </div>
                </div>
        
                <div class="col-12 col-md-6">
                    <div class="form-group mb-3">
                        <label for="subject">Тема:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <span class="icon icon-flag"></span>
                                </div>
                            </div>
                            <input type="text" v-model='model.subject' 
                                   class="form-control input-lg" 
                                   id="subject">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group mb-3">
                        <label for="message">Съобщение*:</label>
                        <div class="form-group">
                            <textarea class="form-control input-lg" 
                                      v-model='model.message' id="message"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="custom-control custom-checkbox mb-3">
                        <input type="checkbox" v-model='model.agreement' id="agreement" class="custom-control-input">
                        <label for="agreement" class="custom-control-label">
                            Прочетох и се съгласявам Videa.bg да събира и обработва личните ми данни според описаната <a href="#" class="link">Политика за поверителност</a>.
                        </label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <form-validator ref='validator' :fields='validatorFields'></form-validator>
                </div>

                <div class="col-12 d-flex justify-content-center">
                    <button @click='send' v-if='!isLoading' class="btn btn-primary btn-lg mt-2"
                            :disabled='!model.agreement'>
                        Изпращане
                    </button>

                    <img v-if='isLoading' width="80px" src='/resources/loader.svg'>
                </div>
            </div>

        </div>

        <div v-if='isSent' class="alert alert-success mt-3">
            <span class="icon icon-check"></span>
            Вашето съобщение е изпратено успешно. Очакваите отговор от нас на посочения е-mail адрес.
        </div>

        <div v-if='failed' class="alert alert-danger mt-3">
            <span class="icon icon-alert-octagon"></span>
            Вашето съобщение не е изпратено. Опитайте отново по-късно или се свържете с нас чрез контактите по-долу.
        </div>
    </div>
</div>


</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                
                isReady : false,
                isLoading : false,

                isSent : false,
                failed : false,

                model : {
                    agreement   : 0,
                    name        : '',
                    email       : '',
                    phone       : '',
                    subject     : '',
                    message     : ''
                },

                         //Validate Project info
                validatorFields : [
                    { 
                        selector  : "#name",
                        minLength : 2,
                        customErr : 'Моля въведете вашето име'
                    },
                    { 
                        selector  : "#phone",
                        minLength : 8,
                        customErr : 'Моля въведете вашият телефонен номер'
                    },
                    { 
                        selector  : "#email",
                        customErr : 'Моля въведете вашият е-мейл адрес'
                    },
                    { 
                        selector  : "#subject",
                        customErr : 'Моля въведете тема'
                    }
                ]

            }
        },

        methods : {

            send() {
                var me = this;

                if( !this.model.agreement ) {
                    $.notify('Моля съгласете се с политиката за поверителност, за да може да изпратите данните си.','warning');

                    return;
                }


                this.$refs.validator.validate({
                    resolve() {

                        me.isLoading = true;

                        me.ajax.call('cmsg:snd', me.model, (r) => {
                            me.isLoading = false;

                            if( r.status == 'success' ) {

                                me.isSent = true;

                            } else {
                                
                                me.failed = true;

                            }


                        })

                    }
                });
            }

        }

    }
</script>
